<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

import TikTokAdsAccountsPopup from '@/app/settings/components/TikTokAdsAccountsPopup.vue';

import ConnectionSuccess from './ConnectionSuccess.vue';

const router = useRouter();

const brand = computed(() => ({ id: router.currentRoute.value.query.brandId }));
const showPopup = ref(true);
</script>

<template>
  <ConnectionSuccess>
    <template #connectionSuccessTitle>
      <p>Your TikTok Ads account has been connected to Dash Social.</p>
    </template>
    <template v-if="showPopup" #popup>
      <TikTokAdsAccountsPopup :brand="brand" @close="showPopup = false" />
    </template>
  </ConnectionSuccess>
</template>
